export default "__VITE_ASSET__BUlCtnOS__"